import { useSelector } from 'react-redux'

import { Button, Typography } from 'primsell-shared-layer/components'

import { walletAddressSelector } from 'primsell-shared-layer/features'

import { BadgeChecked } from 'primsell-shared-layer/assets/icons'

import * as S from './burn-form-info.styles'

import { IBurnFormInfoProps } from './burn-form-info.types'

const BurnFormInfo = ({ title, isConnectButtonDisabled, onWalletConnect, onWalletDisconnect }: IBurnFormInfoProps) => {
  const walletAddress = useSelector(walletAddressSelector)

  return (
    <S.Container>
      <Typography variant="h3">{title}</Typography>
      {!walletAddress ? (
        <S.ConnectWalletContainer>
          <S.DescriptionTypography variant="h5" color="grey">
            To start the Burn NFT process, please, connect your wallet and sign up.
          </S.DescriptionTypography>
          <Button color="dark" variant="filled" onClick={onWalletConnect} disabled={isConnectButtonDisabled}>
            Connect wallet
          </Button>
        </S.ConnectWalletContainer>
      ) : (
        <S.WalletInfoContainer>
          <S.WalletInfoLabel>
            <BadgeChecked />
            <S.WalletInfoTypography>Wallet connected</S.WalletInfoTypography>
          </S.WalletInfoLabel>
          <S.WalletInfoTypography>{`${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}`}</S.WalletInfoTypography>
          <S.DisconnectButton color="grey" variant="outlined" onClick={onWalletDisconnect}>
            Disconnect
          </S.DisconnectButton>
        </S.WalletInfoContainer>
      )}
      <S.Divider />
      <S.ProceedTypography color="grey">
        To receive a unique code for obtaining your product, please proceed with burning your NFT 🔥
      </S.ProceedTypography>
    </S.Container>
  )
}

export { BurnFormInfo }
